export default "__VITE_ASSET___8sGxSmZ__"